import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: any) => ({
	fab: {
		margin: theme.spacing(),
		position: "fixed",
		bottom: theme.spacing(2),
		right: theme.spacing(2)
		
	},
	headerRightContainer: {
		height: "100%"
	}
}));

export default useStyles;
